import type { DestinationDefinition as SourceDefinition } from '@customerio/cdp-action-destinations';
import { createCdpApiClient } from '@/services/api/cdp-api';
import { withCdpTransportErrors } from '@/services/cdp-api';
import type { AvailableSource } from './entity';

/**
 * Hand-written client for the CDP backend's source catalog. CDP has no OpenAPI
 * spec, so these endpoints are not in the generated `hydraUiApi` surface; this
 * follows `message-channel-setting/client.ts`. Failures arrive as
 * HydraUIAPIError, CdpNetworkError or an AbortError; read them with
 * `cdpRequestFailure` from `@/services/cdp-api`.
 */

type Json<T> = { content: { 'application/json': T } };
type WorkspacePath = { workspaceId: number };

interface CdpSourceOptionPaths {
  '/workspaces/{workspaceId}/available_sources': {
    get: { parameters: { path: WorkspacePath }; responses: { 200: Json<{ sources: AvailableSource[] }> } };
  };
  '/workspaces/{workspaceId}/action_sources/{optionId}/manifest': {
    get: { parameters: { path: WorkspacePath & { optionId: string } }; responses: { 200: Json<SourceDefinition> } };
  };
}

const client = createCdpApiClient<CdpSourceOptionPaths>();

export const cdpSourceOptionsApi = {
  list: async (workspaceId: number) => {
    const data = await withCdpTransportErrors(
      client.get('/workspaces/{workspaceId}/available_sources', { params: { path: { workspaceId } } }),
    );
    return data.sources;
  },

  manifest: (workspaceId: number, optionId: string) =>
    withCdpTransportErrors(
      client.get('/workspaces/{workspaceId}/action_sources/{optionId}/manifest', {
        params: { path: { workspaceId, optionId } },
      }),
    ),
};
